import { Component, OnInit } from '@angular/core';
import { DatosService } from '../servicios/datos.service';
import {NgForm, FormGroup, FormControl, Validators} from '@angular/forms';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public submitted = false;

  newsletterForm = new FormGroup({
    'email': new FormControl('', [Validators.required]),
  })

  constructor(
    public _datosService : DatosService
  ){}

  onSubmit() {
    this.submitted = true;
    (this.newsletterForm.valid);
  }

  ngOnInit(){}
  
  SocialMedia  = this._datosService.SocialMedia
}
